<template>
  <div style="height: 100%;width: 100%;">
    <!-- 页眉-->
    <el-row>
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
        <div style="line-height: 40px;text-align: center">
          <img src="../../../assets/images/logo_name.png"
               style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;max-height: 25px;height: 22px">
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
        <div style="line-height: 40px;text-align: center">
          <span style="font-weight: bolder;font-size: 16px;">设备拓扑</span>
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="text-align: right">
        <div style="line-height: 40px;vertical-align: center;margin-right: 1.3vw" @touchstart="closeMapToDcimApp"  @click="closeMapToDcimApp">
          <img src="../../../assets/images/dcim_app_h5/mapBack.png">
          <a class="pointer text-white" style="margin-left: 5px;">退出视图</a>
        </div>
      </el-col>
    </el-row>
    <!-- 拓扑图-->
    <div style="height: 75vh;width: 100%">
      <!-- 横向图-->
      <tree-chart v-show="crosswiseShow" :data="data" ref="treeDiagram" style="height: 75vh;"></tree-chart>
      <!-- 圆径图-->
      <tree-chart v-show="circleShow" :data="data" :extend-data="extendData" ref="treeDiagram" style="height: 75vh;"></tree-chart>
    </div>
    <div style="height: 10vh;width: 100%;position: absolute;top: 85vh;left: 0">
      <el-row style="display: flex;justify-content: flex-end;margin-right: 1.3vw">
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="display: flex;justify-content: flex-end">
          <el-button @touchstart="crosswise"  @click="crosswise">横向</el-button>
          <el-button @touchstart="circle" @click="circle">圆径</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TreeChart from "@/components/echarts/TreeChart";
import {getSpaceDeviceTree} from "@/network/device-info";

export default {
  name: "TreeDiagram",
  components: {TreeChart},
  data() {
    return {
      data: [],
      imgUrl: require('../../../assets/images/topology/主机.png'),
      activeId: '1',
      extendData: null,
      crosswiseShow:true,
      circleShow:false
    }
  },
  mounted() {
    this.getSpaceDeviceTree();
    this.clearAlarmDialog();
    this.extendData = {
      series: [{
        layout: 'radial',
      }]
    }
  },
  methods: {
    // 横向
    crosswise(){
      this.crosswiseShow=true;
      this.circleShow=false;
    },
    // 圆径
    circle(){
      this.crosswiseShow=false;
      this.circleShow=true;
    },
    // 清除实时告警弹窗
    clearAlarmDialog() {
      this.clearAlarmTimer = setInterval(() => {
        if (document.getElementsByClassName('el-notification right').length != 0) {
          for( let i = 0; i < document.getElementsByClassName('el-notification right').length; i++ ) {
            // 清除实时告警弹窗
            document.getElementsByClassName('el-notification right')[i].style.display = 'none'
          }
          // 清除告警弹窗信息定时器
          clearInterval(this.clearAlarmTimer)
          this.clearAlarmTimer = null
        }
      }, 500)
    },
    // 退出视图
    closeMapToDcimApp() {
      this.$confirm('确定要退出设备拓扑吗？', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            // eslint-disable-next-line no-undef
            uni.navigateBack({
              delta: 1
            });
          }
        }
      })
    },
    getSpaceDeviceTree() {
      getSpaceDeviceTree().then(res => {
        this.data = res.data.map(item => {
          if (item.parentId === '-1') {
            item.symbol = "image://" + this.imgUrl;
          }
          return item;
        })
        console.log(this.data);
      })
    }
  },
  destroyed() {
    // 清除告警弹窗信息定时器
    clearInterval(this.clearAlarmTimer)
    this.clearAlarmTimer = null
  }
}
</script>

<style scoped>

</style>
